import {
  ColorClassnameMap,
  VariantClassnameMap,
  GradientBorderClassnameMap,
} from './types';

export const variantClassname: VariantClassnameMap = {
  text: 'disabled:opacity-30',
  contained: 'text-white disabled:opacity-30',
};

export const colorClassname: ColorClassnameMap = {
  secondary: {
    text: '',
    outlined: '',
    contained: 'bg-white-primary hover:bg-white-hover active:bg-white-active',
  },
  info: {
    text: 'text-cyan-500 hover:bg-cyan-50',
    contained: 'bg-cyan-500 hover:bg-cyan-600',
    outlined: 'border-cyan-500 text-cyan-500 hover:bg-cyan-50',
  },
  success: {
    text: 'text-green-500 hover:bg-green-50',
    contained: 'bg-green-500 hover:bg-green-600',
    outlined: 'border-green-500 text-green-500 hover:bg-green-50',
  },
  error: {
    text: 'text-red-primary hover:bg-red-50',
    outlined: 'border-red-300 text-red-400 hover:bg-red-50',
    contained:
      'text-white bg-red-primary-primary hover:bg-red-primary-hover active:bg-red-primary-active',
  },
  warning: {
    text: 'text-yellow-500 hover:bg-yellow-50',
    outlined: 'border-yellow-500 text-yellow-500 hover:bg-yellow-50',
    contained:
      'text-red-primary-primary active:text-white bg-red-secondary-primary hover:bg-red-secondary-hover active:bg-red-secondary-active',
  },
  primary: {
    contained:
      'bg-accent-gradient-primary-primary hover:bg-accent-gradient-primary-hover active:bg-accent-gradient-primary-active',
    text: 'bg-clip-text text-transparent bg-accent-gradient-primary-primary hover:bg-accent-gradient-primary-hover active:bg-accent-gradient-primary-active',
    outlined:
      'bg-accent-gradient-secondary-primary hover:bg-accent-gradient-secondary-hover active:bg-accent-gradient-secondary-active h-[37px] p-[8.5px] rounded-[calc(var(--radius-lg)-1px)] [&>span]:bg-clip-text [&>span]:text-transparent [&>span]:bg-accent-gradient-primary-primary',
  },
};

export const gradientBorderClassname: GradientBorderClassnameMap = {
  primary: {
    outlined: 'p-[1.5px] bg-accent-gradient-primary-primary rounded-lg h-10',
  },
};
